import { DocumentError } from '@/gen/artifacts/v1/model_pb'

import { LEMA_SUPPORT_EMAIL } from '@/const/contact'

import { Hyperlink } from '@/components/lemmala-design-system/link/hyperlink'
import { ERRORS_WITH_CONTACT_LINK } from '@/components/shared/document-status-badge/consts'
import {
  CONTACT_US_LINK_LABEL,
  CONTACT_US_SUFFIX,
  documentErrorMessage,
} from '@/components/shared/document-status-badge/labels'

type DocumentErrorMessageProps = {
  error: DocumentError
}

export const DocumentErrorMessage = ({ error }: DocumentErrorMessageProps) => {
  const message = documentErrorMessage[error]
  if (!message) return null

  return (
    <div>
      {message}
      {ERRORS_WITH_CONTACT_LINK.includes(error) && (
        <>
          {' '}
          <Hyperlink target='_blank' href={`mailto:${LEMA_SUPPORT_EMAIL}`}>
            {CONTACT_US_LINK_LABEL}
          </Hyperlink>{' '}
          {CONTACT_US_SUFFIX}
        </>
      )}
    </div>
  )
}
